var version = {
    "name":      "dativery",
    "buildDateCode": "20260805-134509",
    "buildDate": "Wed Aug 05 2026 13:45:09 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260805-134509",
    "backupUIVersion": "2.2.0-20250522-134816"
}
;
 export default version;